import { render, staticRenderFns } from "./VenueImages.vue?vue&type=template&id=036e99c5&"
import script from "./VenueImages.vue?vue&type=script&lang=js&"
export * from "./VenueImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports